var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Github(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 78.2",
    style: {
      enableBackground: "new 0 0 80 78.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F9F9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70,39.8c0,13.4-8.8,24.8-21,28.6v-7.6c0-2.6-1.1-4.9-2.8-6.5c7.9-1.4,11.8-6,11.8-14.5c0-3.7-0.8-6.6-2.2-8.9 c0.7-2.6,1.1-6.2-0.8-9.2c-3.5,0-6,2.1-7.5,3.8c-2.2-0.5-4.7-0.8-7.5-0.8c-2.7,0-5.2,0.3-7.4,0.9c-1.4-1.7-4-3.9-7.6-3.9 c-2.1,3.4-1.3,7.1-0.5,9.2c-1.6,2.3-2.5,5.2-2.5,8.8c0,8.5,3.9,13.1,11.8,14.5c-1,1-1.8,2.2-2.3,3.5H28c-2.2,0-3-1-4.2-2.5 s-2.4-2.6-3.9-3c-0.8-0.1-1.3,0.6-0.6,1.1c2.4,1.7,2.5,4.5,3.5,6.3c0.9,1.6,2.6,2.7,4.6,2.7H31v6.1c-12.2-3.8-21-15.2-21-28.6 c0-16.6,13.4-30,30-30S70,23.2,70,39.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Github);
export default __webpack_public_path__ + "static/media/icons8-github.fc39acaca53cc54299eb1fe5b6beb6d6.svg";
export { ForwardRef as ReactComponent };